let memberOpening = false;

function setLoginDestination(link) {
  if (!link?.dataset.mdfMemberLoginUrl) return;
  const url = new URL(link.dataset.mdfMemberLoginUrl, window.location.origin);
  if (url.origin !== window.location.origin) return;
  const destination = new URL(window.location.href);
  destination.searchParams.delete('section_id');
  destination.searchParams.delete('sections');
  url.searchParams.set('return_to', destination.pathname + destination.search);
  link.href = url.pathname + url.search;
}

async function openMemberCenter(link, center) {
  memberOpening = true;
  try {
    const mobile = link.closest('dialog-component');
    const popover = link.closest('[popover]');
    const returnFocus = mobile?.querySelector('.account-button') || popover?.parentElement.querySelector('.account-button') || link;
    if (mobile && mobile !== center && typeof mobile.closeDialog === 'function') await mobile.closeDialog();
    if (popover?.matches(':popover-open')) popover.hidePopover();
    center.addEventListener('dialog:close', () => {
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    }, { once: true });
    center.showDialog();
  } finally {
    memberOpening = false;
  }
}

document.addEventListener('click', (event) => {
  const signIn = event.target.closest?.('[data-mdf-member-sign-in]');
  if (signIn) setLoginDestination(signIn);
  const link = event.target.closest?.('[data-mdf-member-open]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const center = document.querySelector('.mdf-member-center');
  if (!center || typeof center.showDialog !== 'function') return;
  event.preventDefault();
  if (memberOpening || center.querySelector('dialog').open) return;
  openMemberCenter(link, center);
});
